"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressLookup = void 0;
const React = require("react");
const react_1 = require("react");
const InputDecoration_1 = require("../../atoms/InputDecoration");
const InputControls_1 = require("../../atoms/InputControls");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "AddressLookup");
const AddressLookup = ({ apiKey, label, description, chosenAddress, onClear }) => {
    var _a;
    const mapScr = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    let addressInput = null;
    // handleScriptLoad = handleScriptLoad.bind(this);
    const clearValue = function () {
        if (addressInput !== null)
            addressInput.value = "";
        typeof onClear === "function" && onClear();
    };
    const handleScriptLoad = () => {
        if (!window.google) {
            return;
        }
        const options = {
            componentRestrictions: { country: "AU" }
        };
        // @ts-ignore
        const autoComplete = new google.maps.places.Autocomplete(addressInput, options);
        autoComplete.addListener("place_changed", () => {
            return chosenAddress(autoComplete.getPlace());
        });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!((_a = window.google) === null || _a === void 0 ? void 0 : _a.maps)) {
            return;
        }
        handleScriptLoad();
    }, [(_a = window.google) === null || _a === void 0 ? void 0 : _a.maps]);
    // handleScriptLoad() {
    //   console.log("address handleScriptLoad");
    //   const options = {
    //     componentRestrictions: { country: "AU" }
    //   };
    //
    //   // @ts-ignore
    //   const autoComplete = new google.maps.places.Autocomplete(
    //     addressInput,
    //     options
    //   );
    //   autoComplete.addListener("place_changed", () =>
    //     chosenAddress(autoComplete.getPlace())
    //   );
    // }
    // componentDidMount() {
    (0, react_1.useEffect)(() => {
        const google = document.getElementById("google");
        if (google) {
            // handleScriptLoad();
            return;
        }
        const s = document.createElement("script");
        s.id = "google";
        s.type = "text/javascript";
        s.src = mapScr;
        s.async = true;
        s.onload = handleScriptLoad;
        document.body.appendChild(s);
    }, []);
    // }
    //
    // componentWillUnmount() {
    //   console.log("unmount");
    //
    //   const autoComplete = document.getElementById("autocomplete");
    //   autoComplete && autoComplete.remove();
    // }
    return (React.createElement("div", { className: css("") },
        React.createElement(InputDecoration_1.InputDecoration, { label: label, description: description, isRequired: true },
            React.createElement(InputControls_1.InputControls, { onClearValue: clearValue },
                React.createElement("input", { type: "text", ref: e => (addressInput = e) })))));
};
exports.AddressLookup = AddressLookup;
//# sourceMappingURL=index.js.map